<template>
  <div class="auth-layout">
    <div class="auth-container">
      <div class="auth-header">
        <h1>PersonaHub</h1>
        <p>Çoklu Marka E-Ticaret Entegrasyon Platformu</p>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthLayout'
}
</script>

<style scoped>
.auth-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #e8eaf6 0%, #c5cae9 50%, #9fa8da 100%);
  position: relative;
  overflow: hidden;
}

/* Mekanik pattern arka plan */
.auth-layout::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,0,0,0.02) 2px, rgba(0,0,0,0.02) 4px),
    repeating-linear-gradient(90deg, transparent, transparent 2px, rgba(0,0,0,0.02) 2px, rgba(0,0,0,0.02) 4px);
  pointer-events: none;
}

.auth-container {
  background: linear-gradient(145deg, #f5f5f5, #ffffff);
  padding: 50px;
  border-radius: 20px;
  box-shadow: 
    0 20px 60px rgba(63, 81, 181, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(63, 81, 181, 0.1);
  min-width: 450px;
  position: relative;
  z-index: 1;
  backdrop-filter: blur(10px);
}

.auth-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #5c6bc0, #3f51b5, #5c6bc0);
  border-radius: 20px 20px 0 0;
}

.auth-header {
  text-align: center;
  margin-bottom: 40px;
}

.auth-header h1 {
  color: #3f51b5;
  margin-bottom: 12px;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  background: linear-gradient(135deg, #3f51b5 0%, #5c6bc0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 10px rgba(63, 81, 181, 0.1);
}

.auth-header p {
  color: #616161;
  font-size: 13px;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-weight: 500;
}
</style>

